export default __webpack_public_path__ + "static/media/journey-timeline-icon.74522bd5.svg";